function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.041 -293.294)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.041 293.294)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.24 1.057A1.842 1.842 0 0 0 .394 2.9v9.231A1.842 1.842 0 0 0 2.24 13.98v1.042a.278.278 0 0 0 .278.278h1.291a.278.278 0 0 0 .278-.278V13.98H8.7v1.042a.278.278 0 0 0 .278.278h1.292a.278.278 0 0 0 .278-.278V13.98a1.842 1.842 0 0 0 1.846-1.846V2.9a1.842 1.842 0 0 0-1.846-1.846zm2.586 2.437h3.137a.278.278 0 0 1 .278.278v1.292a.276.276 0 0 1-.278.276H4.826a.276.276 0 0 1-.278-.276V3.772a.278.278 0 0 1 .278-.278z",
  className: "cls-1",
  transform: "translate(-.394 2.044)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.915.394a.83.83 0 0 0-.831.831v1.347h1.385V2.2a.415.415 0 0 1 .415-.416h1.94a.415.415 0 0 1 .415.416v.377h1.384V1.225a.83.83 0 0 0-.831-.831z",
  className: "cls-1",
  transform: "translate(2.146 -.394)"
})));

var SvgLuggageIcon = function SvgLuggageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17.344,
    viewBox: "0 0 12 17.344",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLuggageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/luggage-icon.0b1d3624.svg";
export { ForwardRef as ReactComponent };